<template lang="html">
    <div class="flex items-center">
        <div>
            <a :href="link" target="_blank">{{text}}</a>
        </div>
        <div class="items-baseline pl-2">
            <a :href="link" target="_blank"><icon name="arrow-top-right-on-square" class="h-5 w-5"/></a>
        </div>
    </div>
</template>

<script>
import Icon from "@/Shared/Icon";

export default {
  components: {
    Icon
  },
  props: {
    text: {
      default: null
    },
    link: String
  }
}
</script>
